export enum BidViewTypesEnum {
    basisCash = 1,
    basisOnly,
    cashOnly,
    futuresOnly
}

export function getBidViewTypeName(bidViewType: BidViewTypesEnum): string {
    switch (bidViewType) {
        case BidViewTypesEnum.basisCash:
            return "Basis & Cash";
        case BidViewTypesEnum.basisOnly:
            return "Basis Only";
        case BidViewTypesEnum.cashOnly:
            return "Cash Only";
        case BidViewTypesEnum.futuresOnly:
            return "Futures Only";
        default:
            return "";
    }
}

export const AllBidViewTypesEnums: BidViewTypesEnum[] = [
    BidViewTypesEnum.basisCash,
    BidViewTypesEnum.basisOnly,
    BidViewTypesEnum.cashOnly,
    BidViewTypesEnum.futuresOnly,
]

export class BidViewType {
    id: number = 0;
    name: string = "";
}

export const AllBidViewTypes: BidViewType[] = AllBidViewTypesEnums.map(id => ({ id, name: getBidViewTypeName(id) }));
